// 강의 판매여부 라디오 값과 서버 값 두 개(is_selling, is_unlisted)를 오간다(EJEDU-194).
// 미노출(unlisted)은 판매 중이지만 사이트 목록·검색·사이트맵에서 빠지고 링크로만 들어오는 강의다.
// 판매불가로 바꾸면 미노출 값도 끈다. 다시 판매로 바꾸면 바로 사이트에 노출된다.
// 모르는 라디오 값은 판매 상태로 저장하지 않고 판매불가로 둔다.
export const SALE_STATUS_OPTIONS = [
  { value: 'selling', label: '판매' },
  { value: 'unlisted', label: '판매(사이트 미노출)' },
  { value: 'notSelling', label: '판매불가' },
];

export const toSaleStatus = (lecture) => {
  if (!lecture?.is_selling) return 'notSelling';
  return lecture.is_unlisted ? 'unlisted' : 'selling';
};

export const fromSaleStatus = (saleStatus) => ({
  is_selling: saleStatus === 'selling' || saleStatus === 'unlisted',
  is_unlisted: saleStatus === 'unlisted',
});

const SALE_STATUS_TEXT = { selling: '판매', unlisted: '미노출', notSelling: '불가' };

export const getSaleStatusText = (lecture) => SALE_STATUS_TEXT[toSaleStatus(lecture)];
